var map = {
	"./angle-left.svg": 1807,
	"./angle.svg": 1808,
	"./arc.svg": 1809,
	"./atomic-design.svg": 1810,
	"./calendar.svg": 1811,
	"./check.svg": 1812,
	"./checkbox.svg": 1813,
	"./checkboxActive.svg": 1814,
	"./checkboxCross.svg": 1815,
	"./checkmarkCircle.svg": 1816,
	"./circle.svg": 1817,
	"./circleArrow.svg": 1818,
	"./circleCheck.svg": 1819,
	"./circleCheckBold.svg": 1820,
	"./circleCrossBold.svg": 1821,
	"./clipboardCheck.svg": 1822,
	"./close.svg": 1823,
	"./copy.svg": 1824,
	"./cross.svg": 1825,
	"./dist.svg": 1826,
	"./docs.svg": 1827,
	"./documentText.svg": 1828,
	"./downloadIcon.svg": 1829,
	"./editIcon.svg": 1830,
	"./exclamationMark.svg": 1831,
	"./facebook.svg": 1832,
	"./facebook_new.svg": 1833,
	"./forwardArrow.svg": 1834,
	"./github.svg": 1835,
	"./google.svg": 1836,
	"./heart.svg": 1837,
	"./home.svg": 1838,
	"./info.svg": 1839,
	"./instagram.svg": 1840,
	"./jest.svg": 1841,
	"./lightbulb.svg": 1842,
	"./linkedin.svg": 1843,
	"./menuBurger.svg": 1844,
	"./moneyHouseIcon.svg": 1845,
	"./pdf.svg": 1846,
	"./pen.svg": 1847,
	"./phone.svg": 1848,
	"./plus.svg": 1849,
	"./quoteLeft.svg": 1850,
	"./react-router.svg": 1851,
	"./react.svg": 1852,
	"./redux.svg": 1853,
	"./searchLense.svg": 1854,
	"./successHouseIcon.svg": 1855,
	"./successIcon.svg": 1856,
	"./suitcase.svg": 1857,
	"./tooltip_icon.svg": 1858,
	"./trash.svg": 1859,
	"./upload.svg": 1860,
	"./userTie.svg": 1861,
	"./warningIcon.svg": 1862,
	"./webpack.svg": 1863,
	"./youtube.svg": 1864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1806;